import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { IFoundZip } from 'src/app/xena-api';

@Injectable({
  providedIn: 'root'
})
export class ZipcodeService {

  constructor(private xenaClient: XenaClient) {
  }

  get(zipcode: string): Observable<IFoundZip> {
    const path = `/Zip?zip=${zipcode}`
    return this.xenaClient.get<IFoundZip>(path);
  }
}
